exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-c7495b8c]{height:500px;padding:24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}input[data-v-c7495b8c],select[data-v-c7495b8c],textarea[data-v-c7495b8c]{border:1px solid #ddd;padding:4px 8px;border-radius:4px;max-width:100%}select[data-v-c7495b8c]{margin-right:8px}textarea[data-v-c7495b8c]{margin-top:12px;width:100%}.label[data-v-c7495b8c]{font-size:13px;margin-bottom:4px}", ""]);

// exports
